<template>
  <b-table
    :dark="dark"
    :hover="hover"
    :striped="striped"
    :bordered="bordered"
    responsive="sm"
    :items="items"
    :fields="captions"
  >
    <template slot="status" slot-scope="data">
      <b-badge :variant="getBadge(data.item.status)">{{data.item.status}}</b-badge>
    </template>
    <template slot="fnsid" slot-scope="data">
      <!-- `data.value` is the value after formatted by the Formatter -->
      <a
        v-bind:href="$trackerBase+ '/tracker_private/includes/alphaReport.php?ftrack=' + data.value"
      >{{ data.value }}</a>
    </template>
  </b-table>
  <!--    <nav>-->
  <!--      <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>-->
  <!--    </nav>-->
</template>

<script>
export default {
  name: "c-table",
  inheritAttrs: false,
  props: {
    caption: {
      type: String,
      default: "Table"
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: [Array, Function],
      default: () => []
    },
    fields: {
      type: [Array, Object],
      default: () => []
    },
    perPage: {
      type: Number,
      default: 5
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      currentPage: 1
    };
  },
  computed: {
    items: function() {
      const items = this.tableData;
      return Array.isArray(items) ? items : items();
    },
    totalRows: function() {
      return this.getRowCount();
    },
    captions: function() {
      return this.fields;
    },
    link: function() {
      return (
        "https://fibernode.com/tracker_private/includes/FNSReport.php?ftrack=" +
        this.item
      );
    }
  },
  methods: {
    getBadge(status) {
      return status === "Active"
        ? "success"
        : status === "Inactive"
        ? "secondary"
        : status === "Pending"
        ? "warning"
        : status === "Banned"
        ? "danger"
        : "primary";
    },
    getRowCount: function() {
      return this.items.length;
    }
  }
};
</script>
